import service from './request'


// 初始化SDG数据列表
export const initReportList = data => {
    return service({
        url: `/sdg/report/init2`,
        method: 'get',
    })
}


// 获取sdg列表
export const reportList = data => {
    return service({
        url: `/sdg/report/list/${data.reportTime}?language=${data.language}`,
        method: 'get',
    })
}

